<template>
  <div class="volvo-selekt-modal" :class="{ 'volvo-selekt-modal-show': isVisible }" @click="handleModalClick">
    <div class="modal-content" @click.stop>
      <div class="modal-head">
        <div @click="(event) => close(event)" class="close" aria-label="Close">
          <img class="icon icon--close" src="/images/icons/ico-close.svg" alt="">
        </div>
        <span class="badge badge--select text-uppercase">{{ badgeText }}</span>
      </div>
      <div class="modal-tooltip" v-html="tooltipContent"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  isVisible: {
    type: Boolean,
    default: false
  },
  tooltipContent: {
    type: String,
    required: true
  },
  badgeText: {
    type: String,
    default: 'Volvo Selekt'
  }
});

const emit = defineEmits(['close']);

function close(event) {
  if (event) {
    event.stopPropagation();
  }
  emit('close');
}

// Handle clicks on the modal element
function handleModalClick(event) {
  // If the click was directly on the modal element (not on its children)
  if (event.target.classList.contains('volvo-selekt-modal')) {
    event.stopPropagation();
    close();
  }
}

// This function is no longer needed as we're handling clicks directly on the modal
function handleOutsideClick(event) {
  // Keep this function for compatibility, but it won't be used
}

// Close modal when pressing Escape key
function handleEscKey(event) {
  if (props.isVisible && event.key === 'Escape') {
    close();
  }
}

// Add event listeners when component is mounted
onMounted(() => {
  // Only add the keydown event listener for the Escape key
  document.addEventListener('keydown', handleEscKey);
});

// Remove event listeners when component is unmounted
onUnmounted(() => {
  // Only remove the keydown event listener
  document.removeEventListener('keydown', handleEscKey);
});

// Prevent scrolling when modal is open
watch(() => props.isVisible, (isVisible) => {
  if (isVisible) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
});
</script>

<style scoped>
.volvo-selekt-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.5s ease, visibility 0.5s ease;
}

.volvo-selekt-modal-show {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.modal-content {
  margin: 0 25px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  width: 90%;
  transform: translateY(-50px);
  transition: transform 0.5s ease;
  position: relative;
}

.volvo-selekt-modal-show .modal-content {
  transform: translateY(0);
}

.modal-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.modal-head .badge {
  max-width: 92px;
}

.modal-head .close {
  position: absolute;
  top: 10px;
  right: 15px;
  cursor: pointer;
  font-size: 20px;
}

.modal-tooltip :deep(p) {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 5px;
  padding-left: 10px;
}

.modal-tooltip :deep(ul) {
  padding-left: 20px;
  margin-bottom: 0;
}
</style>
